export interface BuySubscriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  quantity: number;
  onQuantityChange: (quantity: number) => void;
}

export enum BuySubscriptionModalStep {
  SUMMARY = 1,
  CHECKOUT = 2,
}
